"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
require("./../../utils/style").injectStyle("components/Loading/style/spin.css", "[data-dui-1-12-3~=\"dui-spin\"]{position:relative;width:100%;height:100%}[data-dui-1-12-3~=\"dui-spin-container\"]{position:absolute;left:50%;top:50%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-flow:row nowrap;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;width:48px;height:48px}[data-dui-1-12-3~=\"dui-spin-circle\"]{border-radius:50%;width:100%;height:100%;-webkit-animation:dui-spin-rotate .8s linear infinite;animation:dui-spin-rotate .8s linear infinite;-webkit-box-sizing:border-box;box-sizing:border-box}[data-dui-1-12-3~=\"dui-spin-circle-light\"]{border:4px solid hsla(0,0%,100%,.4);border-top-color:#fff}[data-dui-1-12-3~=\"dui-spin-circle-dark\"]{border:4px solid rgba(0,0,0,.12);border-top-color:rgba(0,0,0,.32)}[data-dui-1-12-3~=\"dui-spin-circle-primary\"]{border:4px solid rgba(30,111,255,.24);border-top:4px solid var(--accent-default,#1e6fff)}@-webkit-keyframes dui-spin-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes dui-spin-rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}");
var theme_1 = require("../../utils/theme");
var VIEW_BOX_SIZE = 48;
var Spin = (function (_super) {
    tslib_1.__extends(Spin, _super);
    function Spin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootRef = React.createRef();
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, type = _a.type, circleClassName = _a.circleClassName, circleStyle = _a.circleStyle;
            var cls = classNames(prefixCls, className);
            var circleCls = classNames(prefixCls + "-circle", prefixCls + "-circle-" + type, circleClassName);
            return (h("div", { className: cls, style: style, ref: _this.rootRef },
                h("div", { className: classNames(prefixCls + "-container"), style: _this.calcContainerTransform() },
                    h("div", { className: circleCls, style: circleStyle }))));
        };
        return _this;
    }
    Spin.prototype.calcContainerTransform = function () {
        var rootDom = this.rootRef.current;
        if (!rootDom) {
            return;
        }
        var width = rootDom.clientWidth, height = rootDom.clientHeight;
        var actualSize = Math.min(width, height);
        var scale = actualSize / VIEW_BOX_SIZE;
        return { transform: "translate(-50%,-50%) scale(" + scale + ")" };
    };
    Spin.prototype.componentDidMount = function () {
        this.forceUpdate();
    };
    Spin.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Spin;
}(React.PureComponent));
exports.default = Spin;
Spin.defaultProps = {
    prefixCls: 'dui-spin',
    type: 'dark'
};
Spin.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    type: PropTypes.oneOf(['light', 'dark', 'primary']),
    circleClassName: PropTypes.string,
    circleStyle: PropTypes.object
};
